<script setup lang="ts">
import { onMounted } from 'vue';
import { RouterView, useRouter } from 'vue-router';
import { useUserStatsStore } from 'src/logic/stores/user-stats.store';

import { Theme } from 'src/shared/ui';

const router = useRouter();
const userStatsStore = useUserStatsStore();

onMounted(() => {
  userStatsStore.initUserStatsWS().then();

  window.addEventListener('storage', (event) => {
    if (event.key === 'referrals-auth') {
      if (!event.newValue) {
        router.push({ name: 'signIn' });
      } else {
        window.location.reload();
      }
    }
  });
});
</script>

<template>
  <Theme>
    <main class="bg">
      <suspense>
        <router-view />
      </suspense>
    </main>
  </Theme>
</template>
